import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AcknowledgementInteractionService } from '../services/acknowledgement-interaction.service';

@Component({
  selector: 'app-acknowledgement-slider',
  templateUrl: './acknowledgement-slider.component.html',
  styleUrls: ['./acknowledgement-slider.component.scss']
})
export class AcknowledgementSliderComponent implements OnInit {
  @Input() isAcknowledgementSliderOpen = false;
  @Output() isAcknowledgementSliderActive = new EventEmitter<boolean>();
  
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() documentEffectiveDate?: Date;
  @Input() documentPhaseNumber!: number;


  constructor(private acknowledgementInteractionService: AcknowledgementInteractionService) {}

  ngOnInit(): void {
    this.acknowledgementInteractionService.closeAndResetAcknowledgementSlider$.subscribe(
      (isClose) => {
        if (isClose) {
          this.closeAndResetAcknowledgementSlider();
        }
      }
    );
  }

  closeSlider() {
    this.acknowledgementInteractionService.openConfirmationDialog();
  }

  closeAndResetAcknowledgementSlider() {
    this.isAcknowledgementSliderOpen = false;
    this.isAcknowledgementSliderActive.emit(this.isAcknowledgementSliderOpen);
  }
}

